import axios from 'axios'
import { get, post, del,getfile } from '@/http/request'
import { HOST } from '@/http/config'

// 列表
export function getBoilerlist(params) {
  return get(`${HOST}basis-boiler/list`, params)
}
// 根据id删除
export function delBoiler(params) {
  return del(`${HOST}basis-boiler/delete`, params)
}
// 详情
export function getBoilerDetails(params) {
  return get(`${HOST}basis-boiler/get`, params)
}
// 新增
export function saveBoiler(params) {
  return post(`${HOST}basis-boiler/save`, params)
}
// 修改
export function updateBoiler(params) {
  return post(`${HOST}basis-boiler/update`, params)
}
//历史修改版本列表
export function getHistoryList(params) {
  return get(`${HOST}basis-boiler-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
  return get(`${HOST}basis-boiler-history/get`, params)
}
// 导出
export function BoilerExport(params) {
  return getfile(`${HOST}basis-boiler/export`, params)
}



// WEBPACK FOOTER //
// ./src/views/baseInfoManagement/specialEquipBoiler/api.js